export function getConversationsList(state) {
    return state.conversationList;
}